export default "__VITE_ASSET__DbwMDnFM__"